import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'languageDialect';

export class LanguageDialect extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
